import React from 'react'
import { Circle, Path, Svg } from 'react-native-svg'
import { IconProps } from '@tabler/icons-react-native'
import { colors } from '@ui/colors'

interface Props extends IconProps {
  value?: number
}
export default function IconPie({ color = colors.text, ...props }: Props) {
  const size = Number(props.size) || 24
  const radius = 20
  const center = 24

  const value = props.value ? Math.min(Math.max(props.value, 0), 100) : 0

  if (value >= 100)
    return (
      <Svg
        width={size}
        height={size}
        viewBox={`0 0 ${center * 2} ${center * 2}`}
      >
        <Circle cx={center} cy={center} r={radius} fill={color} />
      </Svg>
    )

  const angle = (value / 100) * 360
  const largeArcFlag = value > 50 ? 1 : 0
  const radians = (angle - 90) * (Math.PI / 180)
  const x = center + radius * Math.cos(radians)
  const y = center + radius * Math.sin(radians)
  const pathData = `M ${center} ${center} L ${center} ${
    center - radius
  } A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x} ${y} Z`

  const strokeWidth = 4

  return (
    <Svg width={size} height={size} viewBox={`0 0 ${center * 2} ${center * 2}`}>
      {/* Background Circle */}
      <Circle cx={center} cy={center} r={radius} fillOpacity="0" />
      {/* Pie Slice */}
      <Path d={pathData} fill={color} />
      {/* Outer Stroke */}
      <Circle
        cx={center}
        cy={center}
        fill="none"
        stroke={color}
        r={radius - strokeWidth / 2}
        strokeWidth={strokeWidth}
      />
    </Svg>
  )
}
